import { Box, styled } from '@mui/material';

export const FormTipWrap = styled(Box)<{
    isCrit?: boolean;
    disabled?: boolean;
}>(({ theme, isCrit, disabled }) => ({
    display: 'flex',
    gap: '6px',
    color: disabled ? theme.custom.c47 : isCrit ? theme.palette.secondary.main : theme.palette.primary.contrastText,
    svg: {
        fontSize: '1.25rem',
    },
}));
